import { jsx as r } from "react/jsx-runtime";
import "../../base-BUIxijjU.js";
import { useMemo as s } from "react";
import { cssX as a } from "../../core/utils/css.js";
import { c } from "../../index-C7ezJk5b.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import n from "../Loader/Loader.js";
import "react-router-dom";
const L = ({
  style: t,
  className: m,
  testId: i,
  children: o,
  ...e
}) => {
  const p = s(
    () => o ?? /* @__PURE__ */ r(n, { isSimple: !0 }),
    [o]
  );
  return /* @__PURE__ */ r(
    "div",
    {
      style: t,
      "data-testid": i,
      className: c(
        a("SearchBox__loading"),
        m
      ),
      ...e,
      children: p
    }
  );
};
export {
  L as SearchBoxLoading
};
